module.exports = __webpack_public_path__ + "static/media/2.question.1a4cfd6b.mp4";